import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';

import { history } from './helpers/history';
import { Role } from './helpers/role';
import { PrivateRoute } from './components/PrivateRoute';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { AuthService } from './services/authentication.service';
import { LoginPage } from './pages/LoginPage';
import { UserEditPage } from './pages/UserEditPage';
import { UsersPage } from './pages/UsersPage';
import { MentorsPage } from './pages/MentorsPage';
import { MentorEditPage } from './pages/MentorEditPage';
import { RepresentativesPage } from './pages/RepresentativesPage';
import { RepresentativeEditPage } from './pages/RepresentativeEditPage';
import { WorkTaskGroupsPage } from './pages/WorkTaskGroupsPage';
import { WorkTaskGroupEditPage } from './pages/WorkTaskGroupEditPage';
import { WorkTasksPage } from './pages/WorkTasksPage';
import { WorkTaskEditPage } from './pages/WorkTaskEditPage';
import { RemindersByUserPage } from './pages/RemindersByUserPage';
import { ReminderEditPage } from './pages/ReminderEditPage';
import { RemindersLogPage } from './pages/RemindersLogPage';

export default class App extends Component {
  displayName = App.name
  authService: AuthService;

  constructor(props: any) {
    super(props);

    this.authService = new AuthService();
  }

  render() {
    return (
      <Router history={history}>
        <Layout>
          <Route exact path="/" component={Home} />
          <Route path="/login" component={LoginPage} />
          <PrivateRoute path='/users' component={UsersPage} roles={[Role.Admin]} />
          <PrivateRoute path="/reminder/list/:id?" component={RemindersByUserPage} roles={[Role.Admin]}/>
          <PrivateRoute path="/reminder/edit/:id?" component={ReminderEditPage} roles={[Role.Admin]}/>
          <PrivateRoute path="/reminder/log/:id?" component={RemindersLogPage} roles={[Role.Admin]}/>
          <PrivateRoute path="/user/edit/:id?" component={UserEditPage} roles={[Role.Admin]}/>
          <PrivateRoute path='/mentors' component={MentorsPage} roles={[Role.Admin]} />
          <PrivateRoute path="/mentor/edit/:id?" component={MentorEditPage} roles={[Role.Admin]} />
          <PrivateRoute path='/representatives' component={RepresentativesPage} roles={[Role.Admin]} />
          <PrivateRoute path="/representative/edit/:id?" component={RepresentativeEditPage} roles={[Role.Admin]} />
          <PrivateRoute path='/worktaskgroups' component={WorkTaskGroupsPage} roles={[Role.Admin]} />
          <PrivateRoute path="/worktaskgroup/edit/:id?" component={WorkTaskGroupEditPage} roles={[Role.Admin]} />
          <PrivateRoute path="/worktask/editbygroup/:id?" component={WorkTasksPage} roles={[Role.Admin]} />
          <PrivateRoute path="/worktask/edit/:groupId?/:id?" component={WorkTaskEditPage} roles={[Role.Admin]} />
        </Layout>
      </Router>
    );
  }
}